export interface Chapter {
  id: string;
  title: string;
  number: number;
  updateTime: string;
}

export interface Comic {
  id: string;
  title: string;
  author: string;
  cover: string;
  category: string;
  categorySlug: string;
  status: string;
  updateTime: string;
  description: string;
  chapters: Chapter[];
  rating: number;
  views: number;
}

export const comics: Comic[] = [
  {
    id: "comic-1",
    title: "我独自升级",
    author: "Chugong / DUBU",
    cover: "https://readdy.ai/api/search-image?query=Korean%20manhwa%20style%20illustration%20of%20a%20powerful%20male%20hunter%20with%20dark%20hair%20and%20glowing%20eyes%20standing%20in%20a%20dungeon%20with%20shadows%20around%20him%2C%20dramatic%20lighting%2C%20clean%20white%20background%2C%20professional%20digital%20art&width=600&height=840&seq=comic-cover-01&orientation=portrait",
    category: "热血",
    categorySlug: "rexue",
    status: "完结",
    updateTime: "2026-08-03",
    description: "十年前，世界上突然出现了连接异次元的'门'，而能够对抗门内怪物的只有觉醒的'猎人'。成振宇，被称为'人类最弱兵器'的E级猎人，在一次几乎团灭的双重地下城探险中濒死时刻，获得了神秘的系统——'升级系统'。从此，他成为了唯一一个可以不断变强的猎人。为了揭开'门'和系统的秘密，振宇踏上了不断升级的道路。从最弱到最强，一个猎人的逆袭传奇就此展开！",
    chapters: [
      { id: "ch1-1", title: "第1话 人类最弱兵器", number: 1, updateTime: "2024-01-15" },
      { id: "ch1-2", title: "第2话 双重地下城", number: 2, updateTime: "2024-01-22" },
      { id: "ch1-3", title: "第3话 系统的觉醒", number: 3, updateTime: "2024-01-29" },
      { id: "ch1-179", title: "第179话 最终章", number: 179, updateTime: "2026-06-15" }
    ],
    rating: 9.7,
    views: 32500000
  },
  {
    id: "comic-2",
    title: "全知读者视角",
    author: "sing N song / Sleepy-C",
    cover: "https://readdy.ai/api/search-image?query=Korean%20manhwa%20style%20illustration%20of%20a%20young%20man%20reading%20a%20book%20with%20mysterious%20glowing%20symbols%20floating%20around%20him%20in%20a%20post-apocalyptic%20setting%2C%20dramatic%20composition%2C%20clean%20white%20background%2C%20professional%20digital%20art&width=600&height=840&seq=comic-cover-02&orientation=portrait",
    category: "奇幻",
    categorySlug: "qihuan",
    status: "连载",
    updateTime: "2026-08-05",
    description: "金独子是一个平凡的上班族，唯一的爱好就是阅读一部连载了十年的网络小说《在灭亡的世界中生存的三种方法》。当小说完结的那一天，他发现自己所在的世界竟然变成了小说中的场景——末日降临了。凭借对小说剧情的了如指掌，金独子成为了这个末日世界中唯一知道未来走向的人。但这并不意味着他可以轻松生存，因为他知道，这部小说的结局是所有人的毁灭。他必须改变故事的走向，而第一步就是保护那位注定会毁灭世界的'主角'。",
    chapters: [
      { id: "ch2-1", title: "第1话 小说的结局", number: 1, updateTime: "2024-06-01" },
      { id: "ch2-2", title: "第2话 末日降临", number: 2, updateTime: "2024-06-08" },
      { id: "ch2-3", title: "第3话 第一个剧本", number: 3, updateTime: "2024-06-15" },
      { id: "ch2-210", title: "第210话 命运的分歧点", number: 210, updateTime: "2026-08-04" }
    ],
    rating: 9.6,
    views: 28900000
  },
  {
    id: "comic-3",
    title: "剑尊归来",
    author: "LICO / REDICE STUDIO",
    cover: "https://readdy.ai/api/search-image?query=Korean%20manhwa%20style%20illustration%20of%20a%20handsome%20swordsman%20with%20long%20dark%20hair%20holding%20a%20glowing%20sword%20in%20traditional%20martial%20arts%20setting%2C%20elegant%20composition%2C%20clean%20white%20background%2C%20professional%20digital%20art&width=600&height=840&seq=comic-cover-03&orientation=portrait",
    category: "热血",
    categorySlug: "rexue",
    status: "连载",
    updateTime: "2026-08-04",
    description: "一代剑尊陈武黎，在与魔教教主的最终决战中同归于尽。然而当他再次睁开眼睛时，竟发现自己重生回到了二十年前——那个他还只是个末流弟子的时代。带着前世百年修为的记忆与经验，他决心改变一切悲剧的发生。这一次，他要守护所有曾经失去的人，让那些背叛者付出代价。剑尊归来，风云再起！",
    chapters: [
      { id: "ch3-1", title: "第1话 剑尊陨落", number: 1, updateTime: "2024-03-10" },
      { id: "ch3-2", title: "第2话 重生二十年前", number: 2, updateTime: "2024-03-17" },
      { id: "ch3-3", title: "第3话 末流弟子的逆袭", number: 3, updateTime: "2024-03-24" },
      { id: "ch3-156", title: "第156话 宿命的对决", number: 156, updateTime: "2026-08-03" }
    ],
    rating: 9.5,
    views: 21800000
  },
  {
    id: "comic-4",
    title: "外貌至上主义",
    author: "朴泰俊",
    cover: "https://readdy.ai/api/search-image?query=Korean%20manhwa%20style%20illustration%20of%20a%20handsome%20tall%20male%20student%20in%20school%20uniform%20with%20confident%20expression%2C%20clean%20white%20background%2C%20professional%20digital%20art%20with%20crisp%20lines&width=600&height=840&seq=comic-cover-04&orientation=portrait",
    category: "校园",
    categorySlug: "xiaoyuan",
    status: "完结",
    updateTime: "2026-07-20",
    description: "朴玄硕是一个因为外貌而备受欺凌的高中生。肥胖的身材和丑陋的长相让他在学校过着地狱般的生活。绝望之际，他转学到了一个全新的学校。神奇的是，在新学校里他拥有了一个完美的身体——高大帅气、身材完美。白天他享受着完美人生，夜晚却变回原来的样子。双重身份的生活让他逐渐明白了外貌背后的真相，也让他开始思考：真正的自己到底是什么？",
    chapters: [
      { id: "ch4-1", title: "第1话 被欺凌的日常", number: 1, updateTime: "2023-08-01" },
      { id: "ch4-2", title: "第2话 转学的决定", number: 2, updateTime: "2023-08-08" },
      { id: "ch4-3", title: "第3话 新身体新人生", number: 3, updateTime: "2023-08-15" },
      { id: "ch4-310", title: "第310话 真正的美丽", number: 310, updateTime: "2026-07-18" }
    ],
    rating: 9.3,
    views: 45600000
  },
  {
    id: "comic-5",
    title: "女神降临",
    author: "猫咪",
    cover: "https://readdy.ai/api/search-image?query=Korean%20manhwa%20style%20illustration%20of%20a%20beautiful%20young%20woman%20with%20perfect%20makeup%20and%20long%20wavy%20hair%2C%20glamorous%20yet%20elegant%2C%20clean%20white%20background%2C%20professional%20digital%20art&width=600&height=840&seq=comic-cover-05&orientation=portrait",
    category: "恋爱",
    categorySlug: "lianai",
    status: "完结",
    updateTime: "2026-06-30",
    description: "任朱静因为长相不起眼而在学校备受冷落，她唯一的乐趣就是通过化妆教程学习变美的技巧。转学到新学校后，她凭借精湛的化妆技术成功变身'女神'，成为了学校最受欢迎的女生。然而，她的素颜秘密却意外被两个男生发现了——一个是学校冷酷校草李修豪，另一个是神秘转学生韩书俊。一段关于真实与伪装、美丽与自信的校园恋爱故事就此展开。",
    chapters: [
      { id: "ch5-1", title: "第1话 不起眼的女孩", number: 1, updateTime: "2023-03-01" },
      { id: "ch5-2", title: "第2话 化妆的力量", number: 2, updateTime: "2023-03-08" },
      { id: "ch5-3", title: "第3话 女神诞生", number: 3, updateTime: "2023-03-15" },
      { id: "ch5-228", title: "第228话 真正的女神", number: 228, updateTime: "2026-06-28" }
    ],
    rating: 9.2,
    views: 51200000
  },
  {
    id: "comic-6",
    title: "甜蜜家园",
    author: "金坎比 / 黄英璨",
    cover: "https://readdy.ai/api/search-image?query=Korean%20manhwa%20style%20illustration%20of%20a%20young%20man%20in%20a%20dark%20apartment%20building%20with%20monstrous%20shadows%20lurking%2C%20horror%20atmosphere%2C%20clean%20white%20background%2C%20professional%20digital%20art&width=600&height=840&seq=comic-cover-06&orientation=portrait",
    category: "悬疑",
    categorySlug: "xuanyi",
    status: "完结",
    updateTime: "2026-05-15",
    description: "因校园暴力而将自己封闭在房间里的高中生车贤秀，在家人意外离世后搬到了一栋老旧公寓。正当他决定结束自己生命的那天，整个世界突然陷入了一场可怕的灾难——人们开始变异为恐怖的怪物，而这些怪物反映了每个人内心最深处的欲望。被困在公寓中的幸存者们必须团结起来对抗怪物，同时也要面对内心的恐惧。在这场末世浩劫中，贤秀发现自己正在逐渐发生变异……",
    chapters: [
      { id: "ch6-1", title: "第1话 1408号房", number: 1, updateTime: "2023-01-10" },
      { id: "ch6-2", title: "第2话 怪物出现", number: 2, updateTime: "2023-01-17" },
      { id: "ch6-3", title: "第3话 公寓求生", number: 3, updateTime: "2023-01-24" },
      { id: "ch6-140", title: "第140话 甜蜜家园", number: 140, updateTime: "2026-05-10" }
    ],
    rating: 9.4,
    views: 18700000
  },
  {
    id: "comic-7",
    title: "梨泰院Class",
    author: "赵光真",
    cover: "https://readdy.ai/api/search-image?query=Korean%20manhwa%20style%20illustration%20of%20a%20determined%20young%20man%20in%20modern%20streetwear%20standing%20in%20front%20of%20a%20restaurant%20at%20night%2C%20neon%20lights%2C%20clean%20white%20background%2C%20professional%20digital%20art&width=600&height=840&seq=comic-cover-07&orientation=portrait",
    category: "都市",
    categorySlug: "dushi",
    status: "完结",
    updateTime: "2026-04-28",
    description: "朴世路因为坚持正义而得罪了餐饮界巨头张家，被诬陷入狱。出狱后，他决心在梨泰院开一家属于自己的餐厅，向张家复仇。他聚集了一群被社会抛弃的伙伴——前科犯、变性人、黑社会出身的厨师……每个人都有着不为人知的过去。在这个充满偏见的世界上，他们用实力证明自己的价值。这是一个关于梦想、正义与不妥协的热血故事。",
    chapters: [
      { id: "ch7-1", title: "第1话 不妥协的少年", number: 1, updateTime: "2023-05-20" },
      { id: "ch7-2", title: "第2话 入狱", number: 2, updateTime: "2023-05-27" },
      { id: "ch7-3", title: "第3话 梨泰院的夜晚", number: 3, updateTime: "2023-06-03" },
      { id: "ch7-112", title: "第112话 正义的胜利", number: 112, updateTime: "2026-04-25" }
    ],
    rating: 9.1,
    views: 24500000
  },
  {
    id: "comic-8",
    title: "鬼怪",
    author: "金银淑 / OZ",
    cover: "https://readdy.ai/api/search-image?query=Korean%20manhwa%20style%20illustration%20of%20a%20mysterious%20man%20with%20traditional%20Korean%20aesthetics%20and%20supernatural%20aura%2C%20elegant%20and%20melancholic%2C%20clean%20white%20background%2C%20professional%20digital%20art&width=600&height=840&seq=comic-cover-08&orientation=portrait",
    category: "奇幻",
    categorySlug: "qihuan",
    status: "完结",
    updateTime: "2026-03-10",
    description: "金信是一个活了939年的鬼怪，他被自己最信任的人背叛，胸口插着一把只有鬼怪新娘才能看到的剑。只有找到鬼怪新娘，拔出那把剑，他才能结束永恒的生命安息。在现代首尔，他遇到了自称能看见鬼的少女池恩倬——一个从小就能看到亡灵，命运多舛的高中生。当鬼怪遇见了鬼怪新娘，一段跨越千年的爱恋就此展开。",
    chapters: [
      { id: "ch8-1", title: "第1话 939年的等待", number: 1, updateTime: "2023-09-05" },
      { id: "ch8-2", title: "第2话 能看见鬼的少女", number: 2, updateTime: "2023-09-12" },
      { id: "ch8-3", title: "第3话 命运的相遇", number: 3, updateTime: "2023-09-19" },
      { id: "ch8-98", title: "第98话 永恒的约定", number: 98, updateTime: "2026-03-08" }
    ],
    rating: 9.5,
    views: 36700000
  },
  {
    id: "comic-9",
    title: "废柴勇士",
    author: "SEONGWON / Mano",
    cover: "https://readdy.ai/api/search-image?query=Korean%20manhwa%20style%20illustration%20of%20a%20scrawny%20young%20man%20transforming%20into%20a%20muscular%20warrior%20with%20determined%20eyes%2C%20fantasy%20setting%20elements%2C%20clean%20white%20background%2C%20professional%20digital%20art&width=600&height=840&seq=comic-cover-09&orientation=portrait",
    category: "热血",
    categorySlug: "rexue",
    status: "连载",
    updateTime: "2026-08-05",
    description: "在一个人人都有超能力的世界里，金民秀却是唯一一个没有任何能力的'零级'废物。被家族抛弃、被同学嘲笑，他的人生似乎毫无希望。直到有一天，一个神秘的训练系统出现在他面前——这让他看到了变强的可能。从最底层开始，他要用汗水和毅力爬上去，向所有人证明：即使是'废柴'，也能成为最强的勇士。",
    chapters: [
      { id: "ch9-1", title: "第1话 零级废物", number: 1, updateTime: "2025-01-10" },
      { id: "ch9-2", title: "第2话 神秘系统", number: 2, updateTime: "2025-01-17" },
      { id: "ch9-3", title: "第3话 第一步", number: 3, updateTime: "2025-01-24" },
      { id: "ch9-78", title: "第78话 勇者的证明", number: 78, updateTime: "2026-08-04" }
    ],
    rating: 8.9,
    views: 12300000
  },
  {
    id: "comic-10",
    title: "搞笑一家人",
    author: "李顺才",
    cover: "https://readdy.ai/api/search-image?query=Korean%20manhwa%20style%20illustration%20of%20a%20funny%20chaotic%20family%20gathering%20with%20exaggerated%20expressions%2C%20warm%20and%20humorous%2C%20clean%20white%20background%2C%20professional%20digital%20art&width=600&height=840&seq=comic-cover-10&orientation=portrait",
    category: "搞笑",
    categorySlug: "gaoxiao",
    status: "完结",
    updateTime: "2026-07-15",
    description: "李家是一个看似普通却每天都在上演荒诞喜剧的大家庭。有唠叨但疼爱家人的奶奶、严肃又可爱到爆的爷爷、迷糊搞笑的大儿子、精明能干的大儿媳，还有一对活宝孙子孙女。从早餐桌上的战争到客厅里的世界大战，从邻里之间的搞笑矛盾到家庭成员之间的温馨羁绊——这一家人的日常，让你笑到肚子疼的同时感受到家的温暖。",
    chapters: [
      { id: "ch10-1", title: "第1话 早餐大战", number: 1, updateTime: "2024-02-01" },
      { id: "ch10-2", title: "第2话 爷爷的减肥计划", number: 2, updateTime: "2024-02-08" },
      { id: "ch10-3", title: "第3话 谁的袜子", number: 3, updateTime: "2024-02-15" },
      { id: "ch10-185", title: "第185话 我们是一家人", number: 185, updateTime: "2026-07-12" }
    ],
    rating: 9.0,
    views: 15600000
  },
  {
    id: "comic-11",
    title: "社长大人是小学生",
    author: "安小美",
    cover: "https://readdy.ai/api/search-image?query=Korean%20manhwa%20style%20illustration%20of%20a%20cute%20elementary%20school%20student%20in%20a%20business%20suit%20sitting%20at%20a%20CEO%20desk%2C%20playful%20and%20charming%2C%20clean%20white%20background%2C%20professional%20digital%20art&width=600&height=840&seq=comic-cover-11&orientation=portrait",
    category: "搞笑",
    categorySlug: "gaoxiao",
    status: "连载",
    updateTime: "2026-08-04",
    description: "某天，大型企业'未来集团'的全体员工收到了一封震惊的邮件：新任CEO是一位10岁的小学生！这个天才儿童不仅拥有惊人的商业头脑，还用孩子般天真烂漫的方式管理着公司。面对董事会的老顽固、竞争对手的阴谋，以及员工们的质疑，这位小社长用他独特的方式一一化解。当童真撞上成人世界的尔虞我诈，笑料百出的职场喜剧拉开帷幕！",
    chapters: [
      { id: "ch11-1", title: "第1话 新社长的登场", number: 1, updateTime: "2025-03-15" },
      { id: "ch11-2", title: "第2话 董事会风波", number: 2, updateTime: "2025-03-22" },
      { id: "ch11-3", title: "第3话 小学生的经营哲学", number: 3, updateTime: "2025-03-29" },
      { id: "ch11-62", title: "第62话 大人的游戏", number: 62, updateTime: "2026-08-03" }
    ],
    rating: 8.8,
    views: 8900000
  },
  {
    id: "comic-12",
    title: "暗黑骑士的救赎",
    author: "金智勋 / Studio W",
    cover: "https://readdy.ai/api/search-image?query=Korean%20manhwa%20style%20illustration%20of%20a%20dark%20armored%20knight%20with%20a%20somber%20expression%20holding%20a%20broken%20sword%20in%20a%20fantasy%20setting%2C%20dramatic%20and%20emotional%2C%20clean%20white%20background%2C%20professional%20digital%20art&width=600&height=840&seq=comic-cover-12&orientation=portrait",
    category: "奇幻",
    categorySlug: "qihuan",
    status: "连载",
    updateTime: "2026-08-02",
    description: "被誉为大陆最强骑士的艾登，在一次圣战中背叛了自己的信仰，成为了堕落的暗黑骑士。被世人唾弃、被曾经的同伴追杀，他隐姓埋名在边境小镇生活。然而黑暗势力再次崛起，这一次威胁到了他想要守护的所有人。为了赎罪，暗黑骑士必须再次拿起剑——即使这意味着他要与全世界为敌。一个关于背叛、赎罪与救赎的史诗故事。",
    chapters: [
      { id: "ch12-1", title: "第1话 堕落的骑士", number: 1, updateTime: "2025-06-01" },
      { id: "ch12-2", title: "第2话 边境小镇", number: 2, updateTime: "2025-06-08" },
      { id: "ch12-3", title: "第3话 黑暗再临", number: 3, updateTime: "2025-06-15" },
      { id: "ch12-48", title: "第48话 赎罪之路", number: 48, updateTime: "2026-08-01" }
    ],
    rating: 9.2,
    views: 14500000
  },
  {
    id: "comic-13",
    title: "心跳加速的瞬间",
    author: "李素英",
    cover: "https://readdy.ai/api/search-image?query=Korean%20manhwa%20style%20illustration%20of%20a%20blushing%20young%20couple%20almost%20kissing%20under%20cherry%20blossoms%2C%20romantic%20and%20sweet%20atmosphere%2C%20clean%20white%20background%2C%20professional%20digital%20art&width=600&height=840&seq=comic-cover-13&orientation=portrait",
    category: "恋爱",
    categorySlug: "lianai",
    status: "连载",
    updateTime: "2026-08-05",
    description: "韩夏天是一个患有'接触恐惧症'的大学生——她害怕与人有任何形式的肢体接触，即使是最亲近的人。作为艺术系的学生，她习惯用画笔表达自己。直到遇见了宇镇——一个天生带有温暖体温的男孩。当夏天的指尖不小心触碰到他的那一刻，她惊讶地发现：自己竟然没有感到恐惧。一段关于治愈、勇气与初恋的故事，在画笔与心跳之间缓缓展开。",
    chapters: [
      { id: "ch13-1", title: "第1话 触碰恐惧", number: 1, updateTime: "2025-08-10" },
      { id: "ch13-2", title: "第2话 温暖的体温", number: 2, updateTime: "2025-08-17" },
      { id: "ch13-3", title: "第3话 第一次心动", number: 3, updateTime: "2025-08-24" },
      { id: "ch13-45", title: "第45话 拥抱的温度", number: 45, updateTime: "2026-08-03" }
    ],
    rating: 9.0,
    views: 11200000
  },
  {
    id: "comic-14",
    title: "神秘追踪者",
    author: "赵元锡 / 金浩",
    cover: "https://readdy.ai/api/search-image?query=Korean%20manhwa%20style%20illustration%20of%20a%20detective%20with%20sharp%20eyes%20in%20a%20trench%20coat%20standing%20in%20a%20rainy%20alley%2C%20noir%20atmosphere%2C%20clean%20white%20background%2C%20professional%20digital%20art&width=600&height=840&seq=comic-cover-14&orientation=portrait",
    category: "悬疑",
    categorySlug: "xuanyi",
    status: "连载",
    updateTime: "2026-08-04",
    description: "首尔江南区接连发生连环失踪案，受害者都有着共同的特征——他们都曾是网络上的'正义追踪者'，专门曝光社会名流的丑闻。前刑警金道贤被卷入事件中心，他发现每一起失踪案背后都隐藏着一个更加庞大的阴谋。随着调查深入，真相越来越令人不安：那个神秘的追踪者，似乎也在追踪着他。一场猫鼠游戏，谁才是真正的猎物？",
    chapters: [
      { id: "ch14-1", title: "第1话 失踪的正义", number: 1, updateTime: "2025-10-05" },
      { id: "ch14-2", title: "第2话 第一个人", number: 2, updateTime: "2025-10-12" },
      { id: "ch14-3", title: "第3话 蛛丝马迹", number: 3, updateTime: "2025-10-19" },
      { id: "ch14-36", title: "第36话 谁是猎物", number: 36, updateTime: "2026-08-02" }
    ],
    rating: 9.1,
    views: 9800000
  },
  {
    id: "comic-15",
    title: "格斗天才",
    author: "金泰亨",
    cover: "https://readdy.ai/api/search-image?query=Korean%20manhwa%20style%20illustration%20of%20a%20fierce%20fighter%20with%20wrapped%20fists%20in%20a%20fighting%20stance%2C%20intense%20action%20pose%2C%20clean%20white%20background%2C%20professional%20digital%20art&width=600&height=840&seq=comic-cover-15&orientation=portrait",
    category: "动作",
    categorySlug: "dongzuo",
    status: "完结",
    updateTime: "2026-06-20",
    description: "高中生韩宇辰天生拥有超乎常人的格斗天赋，但他只想做一个普通的学生。然而，当他最好的朋友被学校暴力团伙打伤后，宇辰终于决定不再隐藏自己的实力。他踏入了地下格斗的世界，面对一个个强大的对手，不断突破自己的极限。但格斗的世界远比想象中残酷，金钱、权力和鲜血交织在一起，宇辰必须在这条路上找到自己真正的战斗理由。",
    chapters: [
      { id: "ch15-1", title: "第1话 隐藏的实力", number: 1, updateTime: "2024-04-15" },
      { id: "ch15-2", title: "第2话 地下格斗场", number: 2, updateTime: "2024-04-22" },
      { id: "ch15-3", title: "第3话 第一个对手", number: 3, updateTime: "2024-04-29" },
      { id: "ch15-165", title: "第165话 真正的强者", number: 165, updateTime: "2026-06-18" }
    ],
    rating: 9.3,
    views: 19800000
  },
  {
    id: "comic-16",
    title: "校园怪谈笔记",
    author: "尹智恩",
    cover: "https://readdy.ai/api/search-image?query=Korean%20manhwa%20style%20illustration%20of%20students%20exploring%20a%20haunted%20school%20corridor%20with%20flashlights%2C%20supernatural%20horror%2C%20clean%20white%20background%2C%20professional%20digital%20art&width=600&height=840&seq=comic-cover-16&orientation=portrait",
    category: "悬疑",
    categorySlug: "xuanyi",
    status: "连载",
    updateTime: "2026-08-03",
    description: "每所学校都有自己的怪谈，但这所学校的怪谈——是真的。转学生林多恩发现了一张神秘的笔记，上面记录了学校里流传的十大怪谈。起初她以为只是无聊的玩笑，直到她亲眼目睹了第一个怪谈成真。为了揭开笔记的秘密，多恩和几个同学组成了'怪谈调查部'。每解开一个怪谈背后的真相，她们就离学校隐藏的黑暗历史更近一步。",
    chapters: [
      { id: "ch16-1", title: "第1话 转学生的发现", number: 1, updateTime: "2025-11-20" },
      { id: "ch16-2", title: "第2话 十大怪谈", number: 2, updateTime: "2025-11-27" },
      { id: "ch16-3", title: "第3话 第一个怪谈", number: 3, updateTime: "2025-12-04" },
      { id: "ch16-30", title: "第30话 学校的地下室", number: 30, updateTime: "2026-08-01" }
    ],
    rating: 8.7,
    views: 7600000
  }
];

export const getComicsByCategory = (categorySlug: string): Comic[] => {
  return comics.filter(comic => comic.categorySlug === categorySlug);
};

export const getComicById = (id: string): Comic | undefined => {
  return comics.find(comic => comic.id === id);
};

export const getHotComics = (limit: number = 8): Comic[] => {
  return [...comics].sort((a, b) => b.views - a.views).slice(0, limit);
};

export const getLatestComics = (limit: number = 8): Comic[] => {
  return [...comics].sort((a, b) => new Date(b.updateTime).getTime() - new Date(a.updateTime).getTime()).slice(0, limit);
};

export const getCompletedComics = (limit: number = 8): Comic[] => {
  return comics.filter(comic => comic.status === '完结').slice(0, limit);
};

export const getFeaturedComics = (limit: number = 6): Comic[] => {
  return [...comics].sort((a, b) => b.rating - a.rating).slice(0, limit);
};